/* Keep this offer's cart navigation and policies together. Other pages retain their cart. */
(() => {
  const page = document.querySelector('[data-dad-page], [data-dad-cart]');
  if (!page) return;
  const destination = new URL(page.dataset.cartUrl, location.origin);
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== destination.origin || url.pathname !== destination.pathname) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(destination.href);
  }, true);

  // The hidden app's close action navigates back to its own cart route.
  // Release only its CSS scroll lock while this dedicated path is active.
  const releaseLegacyScrollLock = () => {
    for (const element of [document.documentElement, document.body]) {
      if (element.classList.contains('kaching-body__cart-open')) element.classList.remove('kaching-body__cart-open');
    }
  };
  const observer = new MutationObserver(releaseLegacyScrollLock);
  observer.observe(document.documentElement, {attributes:true,attributeFilter:['class']});
  observer.observe(document.body, {attributes:true,attributeFilter:['class']});
  window.addEventListener('load', releaseLegacyScrollLock, {once:true});
  releaseLegacyScrollLock();
})();
